<template>
  <el-form
    size="small"
    :inline="true"
    label-position="top"
    class="w-100 mb-2"
  >
    <el-form-item
      label="Type"
      style="width: 12%;"
    >
      <el-select
        ref="itemTypeSelect"
        v-model="item.type"
        @change="itemSelected"
      >
        <el-option
          v-for="itemType in itemTypes"
          :key="itemType.id"
          :label="itemType.desc"
          :value="itemType.id"
        />
      </el-select>
    </el-form-item>
    <el-form-item
      label="Quantity"
      style="width: 12%;"
    >
      <el-input
        ref="quantityInput"
        v-model="item.quantity"
        class="mousetrap"
      />
    </el-form-item>
    <el-form-item
      label="Weight"
      style="width: 12%;"
    >
      <el-input
        v-model="item.weight"
        class="mousetrap"
      />
    </el-form-item>
    <el-form-item
      label="Length"
      style="width: 12%;"
    >
      <el-input
        v-model="item['length']"
        class="mousetrap"
      />
    </el-form-item>
    <el-form-item
      label="Width"
      style="width: 12%;"
    >
      <el-input
        v-model="item.width"
        class="mousetrap"
      />
    </el-form-item>
    <el-form-item
      label="Height"
      style="width: 12%;"
    >
      <el-input
        v-model="item.height"
        class="mousetrap"
      />
    </el-form-item>
    <el-form-item
      label="Volume"
      style="width: 8%;"
    >
      <el-input
        v-model="item['volume']"
        disabled
        class="mousetrap"
      />
    </el-form-item>
    <el-form-item
      label="Actions"
      style="float: right; width: 12%;"
    >
      <el-switch
        v-model="item.dg"
        active-color="#13ce66"
        inactive-color="#ff4949"
        active-text="DG"
        :active-value="true"
        :inactive-value="false"
      />
      &nbsp;
      <el-button
        type="danger"
        icon="el-icon-delete"
        plain
        size="mini"
        style="margin-left: 5px;"
        class="mousetrap"
        @click.native="$emit('remove', index)"
      />
    </el-form-item>
  </el-form>
</template>
<script>

export default {
  props: {
    item: {
      type: Object,
      required: false,
      default: Object
    },
    itemTypes: {
      type: Array,
      required: false,
      default: Array
    },
    index: {
      type: Number,
      required: true
    },
    accountId: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      accountItems: []
    }
  },
  computed: {
    vol () {
      return (this.item['length'] * this.item.height * this.item.width) / 1000000
    }
  },
  watch: {
    'vol': function (newVal) {
      if (isNaN(newVal)) {
        this.item['volume'] = ''
      } else {
        this.item['volume'] = newVal
      }
    }
  },
  methods: {
    itemSelected () {
      this.$nextTick(() => {
        const quantityInput = this.$refs.quantityInput
        if (!quantityInput) {
          return
        }

        quantityInput.focus()

        // Element UI exposes select() on el-input; fallback to native input ref if needed.
        this.$nextTick(() => {
          if (typeof quantityInput.select === 'function') {
            quantityInput.select()
            return
          }

          const nativeInput = quantityInput.$refs && quantityInput.$refs.input
          if (nativeInput && typeof nativeInput.select === 'function') {
            nativeInput.select()
          }
        })
      })
    },
    accountItemQuerySearch (queryString) {
      if (this.accountId.length < 1) {
        return false
      }

      this.$sdk.account_item.list(builder => {
        builder.context = { resource: 'account', id: this.accountId }
        builder.filters = { 'name': queryString }
        builder.order = { 'name': 'asc' }
      }).then(res => {
        this.accountItems = res
      })
    }
  }
}
</script>
